/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './requestEmailUpdate.defs.js'
export * as $defs from './requestEmailUpdate.defs.js'
